export class MapAsset {
  lat: number;
  lon: number;
  uuid: string;
  representationId: number;
  representationName?: string;
  status?: string;
  hasRepresentationTargetColor: boolean;

  constructor(lat: number, lon: number, uuid: string, representationId: number, representationName?: string, status?: string, hasRepresentationTargetColor?: boolean) {
    this.lat = lat;
    this.lon = lon;
    this.uuid = uuid;
    this.representationId = representationId;
    this.representationName = representationName;
    this.status = status;
    this.hasRepresentationTargetColor = hasRepresentationTargetColor ?? false;
  }

  public getIdentifier() {
    if (!this.hasRepresentationTargetColor) {
      return `${this.representationId}`;
    }
    const idWithStatus: string = `${this.representationId}-${this.status}`;
    return `${this.status ? idWithStatus : this.representationId}`;
  }

  public static cloneWithStatus(mapAsset: MapAsset, status: string): MapAsset {
    return new MapAsset(mapAsset.lat, mapAsset.lon, mapAsset.uuid, mapAsset.representationId, mapAsset.representationName, status, mapAsset.hasRepresentationTargetColor);
  }

}

